import React from 'react';
import { useTranslation } from 'next-i18next';

const SchoolGetStartedTitle = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-overview-title">
      <h1 className="school-main-title h1">
        {t('service.school.gettingStarted.header')}
      </h1>
      <h2 className="school-main-subtitle">
        {t('service.school.gettingStarted.intro')}
      </h2>
    </div>
  );
};

export default SchoolGetStartedTitle;
